/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as components from "../components/index.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type CreateMcpCredentialRequest = {
  serverId: string;
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
  createMcpCredentialRequest: components.CreateMcpCredentialRequest;
};

/** @internal */
export const CreateMcpCredentialRequest$inboundSchema: z.ZodType<
  CreateMcpCredentialRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  server_id: z.string(),
  "X-On-Behalf-Of": z.string().optional(),
  CreateMcpCredentialRequest:
    components.CreateMcpCredentialRequest$inboundSchema,
}).transform((v) => {
  return remap$(v, {
    "server_id": "serverId",
    "X-On-Behalf-Of": "xOnBehalfOf",
    "CreateMcpCredentialRequest": "createMcpCredentialRequest",
  });
});
/** @internal */
export type CreateMcpCredentialRequest$Outbound = {
  server_id: string;
  "X-On-Behalf-Of"?: string | undefined;
  CreateMcpCredentialRequest: components.CreateMcpCredentialRequest$Outbound;
};

/** @internal */
export const CreateMcpCredentialRequest$outboundSchema: z.ZodType<
  CreateMcpCredentialRequest$Outbound,
  z.ZodTypeDef,
  CreateMcpCredentialRequest
> = z.object({
  serverId: z.string(),
  xOnBehalfOf: z.string().optional(),
  createMcpCredentialRequest:
    components.CreateMcpCredentialRequest$outboundSchema,
}).transform((v) => {
  return remap$(v, {
    serverId: "server_id",
    xOnBehalfOf: "X-On-Behalf-Of",
    createMcpCredentialRequest: "CreateMcpCredentialRequest",
  });
});

export function createMcpCredentialRequestToJSON(
  createMcpCredentialRequest: CreateMcpCredentialRequest,
): string {
  return JSON.stringify(
    CreateMcpCredentialRequest$outboundSchema.parse(createMcpCredentialRequest),
  );
}
export function createMcpCredentialRequestFromJSON(
  jsonString: string,
): SafeParseResult<CreateMcpCredentialRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => CreateMcpCredentialRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'CreateMcpCredentialRequest' from JSON`,
  );
}
